module.exports = __webpack_public_path__ + "static/deco-black6-a8fb3c51585ed199081f8509c886c043.svg";